
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent, SidebarComponent } from '@webapp/ui';
import { QUOTER_ROUTE_SEGMENT } from '@webapp/core';
import { QuoteStatus, RiskTypes } from '../../../interfaces/quotes.interface';
import { QuotesStoreService } from '../../../store/quotes-store.service';
import { QuotesDetailSkeletonComponent } from '../quotes-detail-skeleton/quotes-detail-skeleton.component';
import { QuotesDetailComponent } from '../quotes-detail/quotes-detail.component';

@Component({
  selector: 'app-quotes-sidebar',
  imports: [
    SidebarComponent,
    QuotesDetailComponent,
    ButtonComponent,
    QuotesDetailSkeletonComponent
],
  templateUrl: './quotes-sidebar.component.html',
  styleUrl: './quotes-sidebar.component.scss',
})
export class QuotesSidebarComponent {
  quotesStore = inject(QuotesStoreService);

  router = inject(Router);

  loading = this.quotesStore.detailStore.select('loading');

  exitSidebar() {
    this.quotesStore.cleanSelectedQuote();
  }

  downloadQuote() {
    this.quotesStore.downloadQuote();
  }

  convertRiskToQuoterPageRoute(risk: RiskTypes): string {
    const riskToRoute = {
      [RiskTypes.TransportGoods]: 'transporte-de-mercaderias',
    };

    return riskToRoute[risk];
  }

  redirectToQuoter() {
    const selectedQuote = this.quotesStore.get()();
    const selectedCoverageId =
      this.quotesStore.select('selectedCoverage')()?.id;

    if (selectedQuote?.id && selectedCoverageId) {
      this.router.navigate(
        ['polizas', 'nueva', selectedQuote?.id ],
        {
          queryParams: {
            coverageId: selectedCoverageId,
          },
        }
      );
    }
  }

  redirectToInspection() {
    const selectedQuote = this.quotesStore.get()();
    const selectedCoverageId = this.quotesStore.select('selectedCoverage')()?.id;

    if (selectedQuote?.id && selectedCoverageId) {
      this.router.navigate([QUOTER_ROUTE_SEGMENT, 'autos-clasicos'], {
        queryParams: { quoteId: selectedQuote.id, coverageId: selectedCoverageId },
      });
    }
  }

  showEmit() {
    return (
      this.quotesStore.get()()?.status === QuoteStatus.InProgress || this.quotesStore.get()()?.status === QuoteStatus.AcceptedInspection
    );
  }

  showInspect(){
    return this.quotesStore.get()()?.status === QuoteStatus.PendingInspection
  }

  canEmit() {
    const selectedQuoteId = this.quotesStore.get()()?.id;
    const selectedCoverageId =
      this.quotesStore.select('selectedCoverage')()?.id;

    return !!selectedCoverageId && !!selectedQuoteId;
  }

  showSidebar() {
    return this.quotesStore.select('showSidebar')();
  }
}
